/**
 * Relatório Contagem Service - API calls for per-job specific reports
 *
 * Endpoints: /relatorios/{type}/{jobId}/data (JSON) and /relatorios/{type}/{jobId}?format=pdf|excel (blob)
 */
import apiClient from './apiClient';

// JSON data fetchers
// Story 2.42 (extensao): aceita clienteId opcional para filtrar por cliente
// especifico em contagens multi-cliente (resolve bug de itens de KCI aparecendo
// no relatorio com Medtronic selecionado).
export async function getResultadoContagem(jobId: number, clienteId?: number) {
  const params = clienteId ? `?cliente_id=${clienteId}` : '';
  const res = await apiClient.get(`/relatorios/contagem-completa/${jobId}/data${params}`);
  return res.data;
}

export async function getResumoComparativo(jobId: number, clienteId?: number) {
  const params = clienteId ? `?cliente_id=${clienteId}` : '';
  const res = await apiClient.get(`/relatorios/conferencia/${jobId}/data${params}`);
  return res.data;
}

// Story 2.42: aceita clienteId opcional para filtrar por cliente especifico
// em jobs Multi-cliente (resolve bug de logo Medtronic em ticket KCI).
export async function getColetaContagem(jobId: number, clienteId?: number) {
  const params = clienteId ? `?cliente_id=${clienteId}` : '';
  const res = await apiClient.get(`/relatorios/solicitacao-coleta/${jobId}/data${params}`);
  return res.data;
}

export async function getUltimas3Detalhado(jobId: number, dataFim?: string) {
  const params = dataFim ? `?data_fim=${dataFim}` : '';
  const res = await apiClient.get(`/relatorios/ultimas-3-detalhado/${jobId}/data${params}`);
  return res.data;
}

// Blob download helper
export async function downloadRelatorioContagem(url: string, filename: string) {
  const response = await apiClient.get(url, { responseType: 'blob' });
  const blob = response.data as Blob;
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(downloadUrl);
}
